import { render, staticRenderFns } from "./product-list.vue?vue&type=template&id=4495976c&scoped=true"
import script from "./product-list.vue?vue&type=script&lang=js"
export * from "./product-list.vue?vue&type=script&lang=js"
import style0 from "./product-list.vue?vue&type=style&index=0&id=4495976c&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4495976c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins/workspace/web-page/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4495976c')) {
      api.createRecord('4495976c', component.options)
    } else {
      api.reload('4495976c', component.options)
    }
    module.hot.accept("./product-list.vue?vue&type=template&id=4495976c&scoped=true", function () {
      api.rerender('4495976c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "found/views/tpm/views/fee_regular/standard_protect/form/product-list.vue"
export default component.exports